import React, { Component } from "react";
import { connect } from "react-redux";

import Hero from "../../components/Hero";
import Articles from "./Articles";
import Newsletter from "../../components/_common/Newsletter";
import MetaDetail from "../../components/_common/MetaDetail";

import { buildContentAction } from "../../services/content/actions";

import tracking from "../../utils/tracking";
import { HEADER_COPY, BODY_COPY, IMAGE } from "../../utils/content-keys";
import "./brewery.scss";

class TheBreweryPage extends Component {
	moduleNames = [
		{ name: "Hero image", title: "HeroImage" },
		{ name: "Title / Intro copy", title: "HeroCopy" },
		{ name: "Image / Subtitle / Description component", title: "Articles" },
		{ name: "Gallery", title: "Gallery" },
		{ name: "Newsletter sign up module", title: "Newsletter" }
	];

	componentDidMount() {
		tracking.pageView("/the-brewery");

		if (!this.props.data.fetchedData) {
			this.props.fetchData(
				{ name: "theBreweryPage", modules: this.moduleNames, transform: true },
				true,
				"THE BREWERY"
			);
		} else if (!this.props.data.built && this.props.data.data) {
			this.props.buildContentAction(this.props.data.data, {
				name: "theBreweryPage",
				modules: this.moduleNames,
				transform: true
			});
		} else {
			console.log("TheBreweryPage - data fetched");
		}
	}
	render() {
		const { componentData } = this.props;
		const { contents } = this.props.data;
		const meta = {
			title: 'The Brewery',
			description: 'The Open Gate Brewery is the Guinness brewer\'s licence to experiment and dream in beer.',
			canonical: window.location.href
		}

		if (!contents) {
			return null;
		}

		return (
			<div role="main" aria-label="The Brewery Page" className="TheBreweryPage">
				<MetaDetail meta={meta} />
				<Hero
					imageSource={contents.HeroImage[0][IMAGE][0].imgURL}
					srcSet={`${contents.HeroImage[0][IMAGE][1].imgURL} 750w, ${
						contents.HeroImage[0][IMAGE][0].imgURL
						} 1984w`}
					fullWidth={false}
				>
					<div className="TheBreweryPage__hero-panel">
						<h2 role="heading" aria-level="1" className="TheBreweryPage__hero-panel-title">
							{contents.HeroCopy[0][HEADER_COPY].value}
						</h2>
						<p className="TheBreweryPage__hero-panel-copy">
							{contents.HeroCopy[0][BODY_COPY].value}
						</p>
					</div>
				</Hero>
				<Articles items={contents.Articles} />
				<Newsletter
					content={contents.Newsletter[0]}
					formData={componentData.signUpForm}
					fetchData={this.props.fetchData}
					routeProps={this.props.routeProps}
				/>
				{/* <BookCta /> */}
			</div>
		);
	}
}

export default connect(
	() => ({}),
	{ buildContentAction }
)(TheBreweryPage);



// WEBPACK FOOTER //
// ./src/pages/brewery/index.js